// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"58f40d9e","453":"10c44720","455":"ec6e4329","977":"4f99bbf9"}[chunkId] + ".chunk.js";
};